import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { LoadingZone } from '@zenbusiness/application-commons-loading';

import { useBankingPath } from '#client/hooks/useBankingPath';

import { BankingWidgetV2 } from './components/BankingWidgetV2';
import { DocumentsWidgetV1 } from './components/DocumentsWidgetV1';
import { LoadingState } from './components/LoadingState';
import { Widget } from './components/Widget';
import { WidgetArea } from './components/WidgetArea';

function DashboardWidgets() {
  const { entitlements } = useBusinessEntity();
  const hasBankAccount = entitlements.has('banking');
  const bankingDashboardPath = useBankingPath('/dashboard');
  return (
    <LoadingZone
      delayLoadScreen={500}
      fallback={<LoadingState />}
      loadId="DashboardWidgets"
      showPendingAfter={1500}
      timeout={2000}
    >
      <WidgetArea>
        {hasBankAccount && (
          <Widget
            boundaryId="src/components/Widgets/DashboardWidgets#Banking"
            content={BankingWidgetV2}
            moreLinkUrl={bankingDashboardPath}
            title="Banking"
          />
        )}

        <DocumentsWidgetV1 />
      </WidgetArea>
    </LoadingZone>
  );
}

export default DashboardWidgets;
